import { INTEREST_ROUTE } from '../../redux-toolkits/interests/interests.constant'

export const SHOPPING_PREFERENCES_TAB = {
  SPENDING_QUESTIONS: 'spending-questions',
  INTERESTS: 'interests',
} as const

export type ShoppingPreferencesTab =
  (typeof SHOPPING_PREFERENCES_TAB)[keyof typeof SHOPPING_PREFERENCES_TAB]

export const SHOPPING_PREFERENCES_ROUTE = {
  BASE: '/customers/preferences',
  TAB: '/customers/preferences/:tab',
  SPENDING_QUESTIONS: '/customers/preferences/spending-questions',
  INTERESTS: INTEREST_ROUTE.LIST,
} as const

/** Pages that lived at these URLs before the two modules were combined. */
export const LEGACY_SHOPPING_PREFERENCES_ROUTE = {
  SPENDING_QUESTIONS: '/customers/spending-questions',
  INTERESTS: '/customers/interests',
} as const
